export const horizontalLogo = `${process.env.PUBLIC_URL}/horizontalLogo.svg`;
export const verticalLogo = `${process.env.PUBLIC_URL}/verticalLogo.svg`;